<a 
  routerLink="/join/m/{{offerSet.uuid}}/{{offer.uuid}}/{{nextStep}}" 
  class="fixed-option"
  target="_parent"
  [style.pointerEvents]="!offer.membership_product ? 'none' : 'initial'"
  >
  <ng-container *ngIf="!offer.membership_product">
    <em>This option is not currently available</em>
    Code: <code>missing_product</code>
  </ng-container>
  <ng-container *ngIf="offer.membership_product">
    <div class="title">{{ offer.title }}</div>
    <div class="action">{{ offer.action_text }}</div>
    <div class="discount">
      <ng-container *ngIf="offer.price && offer.price !== offer.membership_product.price && offer.price < offer.membership_product.price; else normalDisplay" class="discount">
        <div class="membership price strikethrough">
          {{ offer.membership_product.price / 100 | currency:'USD' }}
        </div>
        <div class="special price">
          {{ offer.price / 100 | currency:'USD' }}{{ period }}
        </div>
      </ng-container>
      <ng-template #normalDisplay>
        <div class="price">{{ (offer.price || offer.membership_product.price) / 100 | currency:'USD' }}{{ period }}</div>
      </ng-template>
    </div>
  </ng-container>
</a>